
import { Minus, Plus } from "lucide-react"

export default function QuantitySelector({ quantity, onIncrease, onDecrease, onQuantityChange, max = 10 }) {
  const handleInputChange = (e) => {
    const value = Number.parseInt(e.target.value)
    if (isNaN(value)) return
    if (value > max) return
    onQuantityChange(value)
  }

  return (
    <div className="flex items-center border border-gray-300 rounded-md">
      <button
        onClick={onDecrease}
        disabled={quantity <= 1}
        className="px-2 py-1 text-gray-600 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Minus size={16} />
      </button>

      <input
        type="text"
        value={quantity}
        onChange={handleInputChange}
        className="w-10 text-center border-none focus:outline-none"
        min="1"
        max={max}
      />

      <button
        onClick={onIncrease}
        disabled={quantity >= max}
        className="px-2 py-1 text-gray-600 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Plus size={16} />
      </button>
    </div>
  )
}